import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const RequiredSignatories = ({ values }) => (
  <Content>
    {({
      businessMandateRequiredSignatoriesLabel,
      businessMandateRequiredSignatoriesValue1,
      businessMandateRequiredSignatoriesValue2,
      businessMandateRequiredSignatoriesValue3,
      businessMandateRequiredSignatoriesDescription,
      globalRadioError
    }) => (
      <Field
        name="no_signatories_to_open"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="no_signatories_to_open"
            title={businessMandateRequiredSignatoriesLabel}
            description={businessMandateRequiredSignatoriesDescription}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.StackedSet
              groupName="businessType-group"
              items={[
                {
                  id: '1',
                  labelText: businessMandateRequiredSignatoriesValue1
                },
                {
                  id: '2',
                  labelText: businessMandateRequiredSignatoriesValue2
                },
                {
                  id: '3',
                  labelText: businessMandateRequiredSignatoriesValue3
                }
              ]}
              selectedId={values.no_signatories_to_open}
              {...input}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);
export default RequiredSignatories;
